import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { ImageEditorModalWithCropComponent } from "./ImageEditorModalWithCropComponent";
import { ImageEditorModalWithCropUIKitComponent } from "./ImageEditorModalWithCropUIKitComponent";

export interface ImageEditorModalWithCropProps {
  aspectRatio?: number;
  attachImage?: ((itemUrl: string, signedId: string) => void) | null;
  closeModal: () => void;
  customAspectRatioHelpText?: string | null;
  formClass?: string;
  hasFile?: boolean;
  hideEmbedUrl?: boolean;
  hideUnsplash?: boolean;
  initialFile?: File | null;
  inputFieldName?: string;
  isCropEnabled?: boolean;
  isPublic?: boolean;
  saveImage?: ((signedId: string) => void) | null;
  setHasFile: (hasFile: boolean) => void;
  setIsLoading?: (isLoading: boolean) => void;
  showModal?: boolean;
  title?: string;
  uploadProgress: (progress: number, fileName: string) => void;
}

export const ImageEditorModalWithCrop = (
  props: ImageEditorModalWithCropProps,
) => {
  const isModalsEnabled = useIsCircleV4FeatureEnabled(
    "circle_v4_modals_enabled",
  );

  if (isModalsEnabled) {
    return <ImageEditorModalWithCropComponent {...props} />;
  }

  return <ImageEditorModalWithCropUIKitComponent {...props} />;
};
